// extracted by mini-css-extract-plugin
export default {"YouTubeSection":"videoSection_YouTubeSection__c-BuY","VideoContainer":"videoSection_VideoContainer__L-BfO","YouTubeIframe":"videoSection_YouTubeIframe__kOhQz"};